import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import BrandLogo from '../shared/BrandLogo';

/**
 * Two-column guest shell for login / signup pages: brand rail on the left,
 * the form on the right with the logo above it.
 */
const GuestLayout: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2 bg-white">
      {/* Brand rail */}
      <div
        className="hidden lg:flex flex-col p-12 text-white"
        style={{ background: 'linear-gradient(160deg, var(--color-primary-hover), var(--color-primary))' }}
      >
        <div className="flex-1 flex items-center">
          <div className="max-w-md">
            <h1 className="text-3xl font-semibold leading-tight">{t('auth.guestHeadline')}</h1>
            <p className="mt-4 text-white/70 leading-relaxed">{t('auth.guestTagline')}</p>
          </div>
        </div>
      </div>

      {/* Form column */}
      <div className="flex items-center justify-center p-6 sm:p-12">
        <div className="w-full max-w-[400px]">
          <div className="flex justify-center mb-8">
            <BrandLogo className="h-16 w-auto" variant="dark" />
          </div>

          {children}
        </div>
      </div>
    </div>
  );
};

export default GuestLayout;
